import script from "./Buylistview.vue?vue&type=script&setup=true&lang=js"
export * from "./Buylistview.vue?vue&type=script&setup=true&lang=js"

import "./Buylistview.vue?vue&type=style&index=0&id=21b76ebc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21b76ebc"]])

export default __exports__